import { memo } from 'react';
import { cn } from '@divlab/divanui';

import Img from '@UI/Img';
import styles from './IconMastercardSecureCode.module.css';
import icon from './securecode.svg';

import type { FC, HTMLAttributes } from 'react';

export interface IconProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const IconMastercardSecureCode: FC<IconProps> = ({ className }) => {
  return (
    <Img
      src={icon}
      className={cn(styles.icon, className)}
      alt='Принимаем оплату банковскими картами MasterCard SecureCode'
    />
  );
};

export default memo(IconMastercardSecureCode);
